import axios from 'axios';
import store from '../store'

const api = axios.create({
    baseURL: process.env.VUE_APP_URL_API_COMUNICADOS
});

const getAuthHeaders = token => ({
    Authorization: `Bearer ${token}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
});

export default {
    async getRemitentes(filters) {
        try {
            const response = await api.get('clients/compania/remitentes', {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getRemitente(remitente_id) {
        try {
            const response = await api.get(`clients/compania/remitentes/${remitente_id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
    
            return response.data;
        } 
        catch (error) {
            console.error("Error al obtener un remitente por id: ", error);
        }
    },
    async updateRemitente(remitente_id, data) {
        try {
            const response = await api.put(`clients/compania/remitentes/${remitente_id}`, data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async createRemitente(data)
    {
        try
        {
            const response = await api.post('/clients/compania/remitentes', data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            
            return response.data;
        }
        catch(error)
        {
            console.error(error);
            throw error;
        }
    },
    async borrarRemitente(id) {
        try {
            const response = await api.delete(`clients/compania/remitentes/${id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {

            console.error(error);
            throw error;
        }
    },
    async getBoletines(filters) {
        try {
            const response = await api.get('clients/compania/comunicados', {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
          
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getBoletin(id)
    {
        try 
        {
            const response = await api.get(`clients/compania/comunicados/${id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });

            return response.data;
        } 
        catch (error) 
        {
            console.error("Error al obtener un boletin por id: ", error);
        }
    },

    async enviarPruebaBoletin(id, data)
    {
        try 
        {
            const response = await api.post(`clients/compania/comunicados/${id}/prueba`, data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
           
            return response.data;
        } 
        catch (error) 
        {
            console.error("Error al obtener un boletin por id: ", error);
        }
    },
    async enviarBoletin(id)
    {
        try 
        {
            const response = await api.post(`clients/compania/comunicados/${id}/enviar`, {}, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
           
            return response.data;
        } 
        catch (error) 
        {
            console.error("Error al obtener un boletin por id: ", error);
        }
    },

    async getUltimosBoletines()
    {
        try {
            const response = await api.get('clients/compania/dashboard/comunicados-enviados', {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);

            throw error;
        }
    },

    async getEstadisticasGenerales(fechas)
    {
        try 
        {
            const response = await api.get('/clients/compania/dashboard/estadisticas-generales', {
                params: fechas,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } 
        catch (error) 
        {
            console.error(error);
            throw error;
        }
    },

    async createBoletin(data) {
        try {
            const response = await api.post('clients/compania/comunicados', data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async updateBoletin(id, data) {
        try {
            const response = await api.put(`clients/compania/comunicados/${id}`, data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async borrarBoletin(id) {
        try {
            const response = await api.delete(`clients/compania/comunicados/${id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },

    async duplicarBoletin(id){

        try {
            const response = await api.post(`clients/compania/comunicados/${id}/duplicar`,{}, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });

            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },

    async getCarpetasBoletines(filters) {
        try {
            const response = await api.get('clients/compania/carpetas-comunicados', {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async createCarpetasBoletines(data) {
        try {
            const response = await api.post('clients/compania/carpetas-comunicados', data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async updateCarpetasBoletines(data) {
        try {
            const response = await api.put(`clients/compania/carpetas-comunicados/${data.id}`, data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async deleteCarpetasBoletines(id) {
        try {
            const response = await api.delete(`clients/compania/carpetas-comunicados/${id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },    
    async getGruposSubscriptores(filters) {
        try {
            const response = await api.get('clients/compania/grupos', {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getGrupos(filters) {
        try {
            const response = await api.get('clients/compania/grupos', {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getActividadReciente() {
        try {
            const response = await api.get('clients/compania/dashboard/actividad-reciente', {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token)
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async createGrupo(data) {
        try {
            const response = await api.post('clients/compania/grupos', data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async updateGrupo(grupo_id, data) {
        try {
            const response = await api.put(`clients/compania/grupos/${grupo_id}`, data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getGrupo(grupo_id) {
        try {
            const response = await api.get(`clients/compania/grupos/${grupo_id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async deleteGrupo(grupo_id) {
        try {
            const response = await api.delete(`clients/compania/grupos/${grupo_id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async vincularSubscriptoresGrupo(grupo_id, data) {
        try {
            const response = await api.post(`clients/compania/grupos/${grupo_id}/vincular-subscriptores`, data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },   
    async getSubscriptores(filters) {
        try {
            const response = await api.get('clients/compania/subscriptores', {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },     
    async getSubscriptor(subscriptor_id) {
        try {
            const response = await api.get(`clients/compania/subscriptores/${subscriptor_id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async createSubscriptor(data) {
        try {
            const response = await api.post('clients/compania/subscriptores', data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },      
    async updateSubscriptor(subscriptor_id, data) {
        try {
            const response = await api.put(`clients/compania/subscriptores/${subscriptor_id}`, data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async deleteSubscriptor(subscriptor_id) {
        try {
            const response = await api.delete(`clients/compania/subscriptores/${subscriptor_id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async desvincularUsuarioDeGrupo(subscriptor_id, grupo_id) {
        try {
            const response = await api.delete(`clients/compania/grupos/${grupo_id}/desvincular-subscriptores`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
                data: { subscriptores: [subscriptor_id] }
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async exportarSubscriptores(data) {
        try {
            const response = await api.post(`clients/compania/subscriptores/exportar`, data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getSubscriptorMailSend(subscriptor_id, data) {
        try {
            const response = await api.get(`clients/compania/subscriptores/${subscriptor_id}/emails-enviados`, {
                params: data,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getSubscriptorMailVisualizaciones(subscriptor_id, data) {
        try {
            const response = await api.get(`clients/compania/subscriptores/${subscriptor_id}/listadoVisualizaciones`, {
                params: data,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getSubscriptorMailClicks(subscriptor_id, data) {
        try {
            const response = await api.get(`clients/compania/subscriptores/${subscriptor_id}/listado-clicks`, {
                params: data,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getResumen(filters) {
        try {
            const response = await api.get('clients/compania/dashboard/resumen', {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getCarpetasImagenes(filters) {
        try {
            const response = await api.get('clients/compania/carpetas-imagenes', {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async createCarpetasImagenes(data) {
        try {
            const response = await api.post('clients/compania/carpetas-imagenes', data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async updateCarpetasImagenes(data) {
        try {
            const response = await api.put(`clients/compania/carpetas-imagenes/${data.id}`, data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async deleteCarpetasImagenes(id) {
        try {
            const response = await api.delete(`clients/compania/carpetas-imagenes/${id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }


    },   
        
    async getImagenesMedios(filters) {
        try {
            const response = await api.get('clients/compania/imagenes', {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }, 

    async getPaises(){
        try {
            const response = await api.get('clients/ubicaciones/paises',{
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });

            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },

    async createImagenesMedios(data) {
        try {
            const response = await api.post('clients/compania/imagenes', data, {
                headers: { 
                    ...getAuthHeaders(store.getters.getTeatro.marketing_api_token),
                    'Content-Type': 'multipart/form-data',
                }
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },

    async getProvincias(id){
        try {
            const response = await api.get(`clients/ubicaciones/paises/${id}/provincias`,{
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {

            console.error(error);
            throw error;
        }
    },

    async getLocalidades(idPais, idProvincia){
        try {
            const response = await api.get(`clients/ubicaciones/paises/${idPais}/provincias/${idProvincia}/localidades`,{

                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async importarSubscriptoresAGrupo(grupoId, data) {
        try {
            const response = await api.post(`clients/compania/grupos/${grupoId}/importar-usuarios`, data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });

            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },

    async getListadoImportaciones()
    {
        try
        {
            const response = await api.get('clients/compania/importaciones',{
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        }
        catch(error)
        {
            console.error(error);
            throw error;
        }
    },

    async getImportacion(id)
    {
        try {
            const response = await api.get(`clients/compania/importaciones/${id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },

    async getInformeSpam(comunicado)
    {
        try {
            const response = await api.post(`clients/compania/comunicados/${comunicado}/spamAssassin`, {} , {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });

            return response.data;   
        } catch (error) {
            console.error(error);
            throw error;
        }
    },

    async getEstadisticasGeneralesBoletin(comunicado, fechas = {})
    {
        try {
            const response = await api.get(`clients/compania/comunicados/${comunicado}/estadisticas-generales` ,{
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
                params: fechas
            })

            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },

    async getResumenBoletin(comunicado,  fechas = {})
    {
        try {
            const response = await api.get(`clients/compania/comunicados/${comunicado}/resumen` ,{
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
                params: fechas
            })

            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },

    async getActividadRecienteBoletin(comunicado)
    {
        try {
            const response = await api.get(`clients/compania/comunicados/${comunicado}/actividades-recientes`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            
            return response.data;

        } catch (error) {
            console.error(error);
            throw error;
        }
    },

    async getListadoPlantillas(filters = {})
    {
        try {
            const response = await api.get(`clients/compania/email-templates` , {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });

            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async createPlantilla(data) {
        try {
            const response = await api.post('clients/compania/email-templates', data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },

    async borrarPlantilla(id)
    {
        try {
            const response = await api.delete(`clients/compania/email-templates/${id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });

            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getPlantilla(id)
    {
        try {
            const response = await api.get(`clients/compania/email-templates/${id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async editarPlantilla(id, data)
    {
        try {
            const response = await api.put(`clients/compania/email-templates/${id}`, data, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getEntradasCarrito(subscriptor, filters)
    {
        try {
            const response = await api.get(`clients/compania/subscriptores/${subscriptor}/carritos`, {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getEntradasCompradas(subscriptor, filters)
    {
        try {
            const response = await api.get(`clients/compania/subscriptores/${subscriptor}/compras`, {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
};